<script>
    import {onMount} from 'svelte';
    import _ from 'lodash';
    import {precision} from '../config.js';
    import {put_item} from '../helpers.js';
    import {store, network} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import HeaderSwitcher from '../components/HeaderSwitcher.svelte';
    import Footer from "../components/Footer.svelte";

    export let location;
    export let inside;
    export let components;
    export let options;

    const axis = store('axis', '', false);

    let
        id = null,
        item = null,
        mounting = null,
        packing = null,
        errors = false,
        allow_leave = true
    ;

    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    const set_item = _.debounce((event) => {
        item = _.merge({}, network.item, event.detail);
        item.price.rozn = fixprecision(item.price.rozn);
        item.price.opt = fixprecision(item.price.opt);
        item.oprice.rozn = fixprecision(item.oprice.rozn);
        item.oprice.opt = fixprecision(item.oprice.opt);

        errors = !!document.querySelectorAll('[data-error]').length;
    }, 300);

    const set_mounting = _.debounce((event) => {
        mounting = event.detail;
    }, 300);

    const set_packing = _.debounce((event) => {
        packing = event.detail;
    }, 300);

    const reset = _.debounce(() => {
        id = null;
        allow_leave = true;
    }, 100);

    const lock_leave = _.debounce((event) => {
        allow_leave = !!event.detail.state;
    }, 100);

    // при загрузке проверяем есть ли какой-то товар на редактировании
    onMount(() => [id, item] = put_item());
</script>

<TopMenu title="Калькулятор" {allow_leave} on:lock={lock_leave} />

<div id="appCapsule" class="{$axis ? 'pt-1' : ''}">
    <div class="section">
        <div class="row">
            <div class="col-12 col-lg-6 mx-md-auto mb-2">
                <div class="card mb-2">
                    <HeaderSwitcher {allow_leave} on:lock={lock_leave} />
                    <svelte:component this={inside} on:item={set_item} on:mounting={set_mounting} on:packing={set_packing} on:reset={reset} on:lock={lock_leave} {options}/>
                </div>

                {#each components as part}
                    {#key part.name}
                        {#if part.name === 'CalcMounting' || part.name === 'CalcPacking' } <!--// монтаж добавлять на стороне калькулятора, можно на будущее завязаться на Calc в названии-->
                            <div class="card mb-2">
                                <svelte:component this={part} on:reset={reset} on:lock={lock_leave} args={{id, item, mounting, packing, errors}}/>
                            </div>
                        {/if}
                    {/key}
                {/each}
            </div>

            <div class="col-12 col-lg-6 mx-md-auto">
                <div class="sticky-top" >
                    {#each components as part}
                        {#key part.name}
                            {#if part.name !== 'CalcMounting' && part.name !== 'CalcPacking' }
                                <div class="card mb-2">
                                    <svelte:component this={part} on:reset={reset} on:lock={lock_leave} args={{id, item, mounting, packing, errors}}/>
                                </div>
                            {/if}
                        {/key}
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>

<Footer />

<div class="modal fade dialogbox" id="item-add" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-icon text-success">
                <i class="far fa-check-circle"></i>
            </div>
            <div class="modal-header">
                <h5 class="modal-title">Добавлено в заказ</h5>
            </div>
            <div class="modal-footer">
                <div class="btn-inline">
                    <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade dialogbox" id="item-upgrade" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-icon text-success">
                <i class="far fa-check-circle"></i>
            </div>
            <div class="modal-header">
                <h5 class="modal-title">Изменено в заказе</h5>
            </div>
            <div class="modal-footer">
                <div class="btn-inline">
                    <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade dialogbox" id="item-update" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-icon text-success">
                <i class="far fa-check-circle"></i>
            </div>
            <div class="modal-header">
                <h5 class="modal-title">Обновлено в заказе</h5>
            </div>
            <div class="modal-footer">
                <div class="btn-inline">
                    <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade dialogbox" id="leave-locker" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-icon text-danger" data-bs-dismiss="modal">
                <i class="fas fa-times"></i>
            </div>
            <div class="modal-header">
                <h5 class="modal-title">Внимание:</h5><br>

            </div>
            <div class="modal-body" >
                <p>Выбранные позиции не добавлены в корзину, выбор будет потерян при смене раздела.</p>
            </div>

            <div class="modal-footer">
                <div class="btn-inline">
                    <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                </div>
            </div>
        </div>
    </div>
</div>
